import { render, staticRenderFns } from "./Co2Metrics.vue?vue&type=template&id=6ea2e39f&scoped=true&"
import script from "./Co2Metrics.vue?vue&type=script&lang=js&"
export * from "./Co2Metrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea2e39f",
  null
  
)

export default component.exports